<template>
  <a-modal
    :visible="visible"
    :width="960"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :footer="null"
    @cancel="handleCancel"
    centered
  >
    <template slot="title">
      <span style="font-size: 18px; font-weight: 800">状态变更</span>
      <a-button type="primary" size="small" style="margin-left: 12px; margin-top: -4px; top: -1px">
        p_0001
      </a-button>
    </template>
    <div>
      <div style="display: flex">
        <img :src="svg1" alt="" style="width: 34px; height: 34px; margin-top: 6px" />
        <div style="margin-left: 12px; font-size: 14px; font-weight: 500">
          <div>来源：参考消息网</div>
          <dir>1小时前</dir>
        </div>
      </div>
      <div style="font-size: 18px; font-weight: 700; margin-top: 31px">
        外媒关注：外媒关注：俄将向白俄罗斯提供“核支持
      </div>
      <div style="font-size: 14px; font-weight: 500; color: #595959; margin-top: 24px">
        另据塔斯社报道,普京在会见中还提议在俄罗斯的工厂升级白俄罗斯空军的苏-25攻击机。俄总统指出,白俄罗斯军队拥有相当庞大的苏-25机群。普京提议:“可以为它们配齐装备。当然,升级工作应在俄罗斯的飞机制造厂进行,但我们将商定何时进行,以及何时开始为飞行员进行相关培训。”
      </div>
      <!-- <img src="./imgs/test.png" alt="" /> -->
      <div style="margin-top: 14px">
        <a-tag color="blue">苏-25攻击机</a-tag>
        <a-tag color="blue">白俄罗斯</a-tag>
        <a-tag color="blue">普京</a-tag>
      </div>
      <div style="text-align: right">
        <a-pagination v-model="current" :total="50" :pageSize="1"></a-pagination>
      </div>
    </div>
  </a-modal>
</template>

<script>
import svg1 from './imgs/ddyz_sel.svg'
export default {
  data() {
    return {
      current: 1,
      confirmLoading: false,
      visible: false,
      layout: 'horizontal',
      svg1,
      form: {
        juese: undefined,
        name: undefined,
        people: undefined
      },
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        juese: [{ required: true, message: '请输入角色类型', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      }
    }
  },
  methods: {
    showModel() {
      this.visible = true
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>

<style></style>
